var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',{style:(("color:" + (_vm.globalColors.primary)))},[_vm._v("404")]),_vm._v(" "),_c('h2',{style:(("color:" + (_vm.globalColors.base)))},[_vm._v("(0.0)")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'page-home' }}},[_vm._v("Inicio")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047e22c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/not-found.vue
// module id = 1450
// module chunks = 27